<template>
    <router-view />
</template>

<script>
    export default {
        name: 'RealworksStatusRule',
    }
</script>

<style scoped>

</style>